import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import group9 from "../../images/LandingPageImage/about_us.webp";
import CtaSection from "./CTASection";
import FaqSection from "./FAQ";
import usePlans from "../../services/LandingPage/usePlans";
import useHeatMap from "../../services/LandingPage/useHeatMap";

const AboutUs = ({ onLoginClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isVisible, setIsVisible] = useState(false);
  const [sessionID, setSessionId] = useState("");
  const [campaignIdHook, setCampaignIdHook] = useState("");

  const { plans, loading: loadingPlans } = usePlans("IN", "");
  const { trackClick } = useHeatMap();

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const generateUUID = () => {
    if (crypto?.randomUUID) return crypto.randomUUID();

    return "xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  useEffect(() => {
    const storedSessionID = sessionStorage.getItem("sessionID");
    if (storedSessionID) {
      setSessionId(storedSessionID);
    } else {
      const newSessionID = generateUUID();
      sessionStorage.setItem("sessionID", newSessionID);
      setSessionId(newSessionID);
    }
  }, []);

  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    let campaignid = params.get("campaignid");

    if (!campaignid) {
      params = new URLSearchParams(window.location.hash.substring(1));
      campaignid = params.get("campaignid");
    }

    if (campaignid) {
      sessionStorage.setItem("campaignId", campaignid);
      setCampaignIdHook(campaignid);
    }
  }, []);

  const handleButtonClick_SEO = async (buttonName) => {
    const urlParams = new URLSearchParams(window.location.search);
    const storedTrackingData =
      JSON.parse(sessionStorage.getItem("trackingData")) || {};

    const requestBody = {
      campaignid: campaignIdHook,
      sessionid: sessionID,
      element: "Button",
      button_name: buttonName,
      pageurl: window.location.href,
      pagename: "About Page",
      product: "Anlook",
      utm_source: urlParams.get("utm_source") || storedTrackingData.utm_source,
    };

    await trackClick(requestBody);
  };

  const handleGetStarted = async () => {
    await handleButtonClick_SEO("Get Started");

    navigate("/get-started", {
      state: {
        plan: plans,
      },
    });
  };

  // const handlePricing = async () => {
  //   await handleButtonClick_SEO("See Pricing");
  //   navigate("/pricing-page");
  // };

  useEffect(() => {
    const pageKey = location.pathname;
    const storageKey = `freeTrialClosed_${pageKey}`;
    return () => sessionStorage.removeItem(storageKey);
  }, [location.pathname]);

  useEffect(() => {
    if (document.getElementById("seo-script")) return;

    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);

    const script = document.createElement("script");
    script.id = "seo-script";
    script.src = `https://anlook.com/SeoBix/seo_injection.php?webid=56c53e1ff4273fa3746b406c70f5bf9c&url=${encodedUrl}&baseUrl=https%3A%2F%2Fanlook.com`;
    script.async = true;

    document.body.appendChild(script);
  }, []);

  return (
    <>
      <Navbar onLoginClick={onLoginClick} />
      {/* first Section */}
<section className="w-full min-h-[500px] md:min-h-[520px] lg:min-h-[500px] xl:min-h-[540px] pt-[78px] sm:pt-[80px] lg:pt-0 bg-gradient-to-br from-[#0C4D45] to-[#01C37D] flex items-end overflow-hidden">
  <div className="max-w-[1600px] mx-auto w-full flex flex-col lg:flex-row items-center lg:items-end justify-between px-6 lg:px-16 gap-6 lg:gap-12 lg:py-0">
    {/* LEFT */}
    <div className="w-full flex-1 flex flex-col justify-center max-w-[720px] text-center lg:text-left self-center lg:self-center">
      <h1
        className={`text-[2rem] lg:text-[3rem] font-bold leading-[1.2] text-white transition-all duration-[900ms] ease-out transform ${
          isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-[110%]"
        }`}
      >
        <span className="text-[#02C37D]">Smarter Business</span>
        <br />
        Conversations on WhatsApp
      </h1>

      <p
        className={`mt-4 text-[1.05rem] lg:text-[1.125rem] text-white leading-6 max-w-[45ch] mx-auto lg:mx-0 transition-all duration-[900ms] ease-out delay-[150ms] transform ${
          isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-[110%]"
        }`}
      >
        At Anlook, we help businesses turn everyday WhatsApp messages into
        meaningful customer interactions.
      </p>

      <div
        className={`mt-6 flex flex-wrap justify-center lg:justify-start gap-3 transition-all duration-[900ms] ease-out delay-[250ms] transform ${
          isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-[110%]"
        }`}
      >
        <button
          onClick={handleGetStarted}
          disabled={loadingPlans}
          className="px-5 py-2.5 font-bold rounded-lg bg-[#02C37D] text-white hover:bg-[#54BD95] disabled:opacity-50 transition duration-200"
        >
          Start Free Trial
        </button>
      </div>
    </div>

    {/* RIGHT */}
    <div className="flex-1 flex items-end justify-center self-end max-w-[720px] h-[260px] sm:h-[300px] md:h-[330px] lg:h-[470px] xl:h-[520px] overflow-hidden">
      <img
        src={group9}
        alt="WhatsApp automation illustration"
        loading="lazy"
        draggable={false}
        className={`w-full h-full object-contain object-bottom translate-y-0 transition-all duration-[900ms] ease-out transform delay-[120ms] ${
          isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-[80%]"
        }`}
      />
    </div>
  </div>
</section>

      {/* Second Section */}
      <div className="max-w-[1200px] mx-auto px-5 py-16">
        <h2 className="text-[32px] font-bold text-[#0C4D45] text-center max-w-[600px] mx-auto mb-6">
          Helping Businesses Grow Smarter with WhatsApp Automation
        </h2>

        <p className="text-[16px] text-[#444] text-center max-w-[850px] mx-auto mb-4">
          Today’s customers expect fast responses and relevant conversations.
          Delayed replies and manual messaging can slow growth. That’s where
          Anlook makes the difference.
        </p>

        <p className="text-[16px] text-[#444] text-center max-w-[850px] mx-auto mb-4">
          We help businesses scale smarter by automating WhatsApp conversations
          without losing the personal touch. Anlook enables brands to stay
          available 24/7, guide customers through intelligent chat flows, and
          handle high volumes of conversations with ease.
        </p>

        <p className="text-[16px] text-[#444] text-center max-w-[850px] mx-auto mb-4">
          By using Anlook, businesses can respond faster, improve customer
          satisfaction and boost conversions while reducing manual effort and
          operational costs. It’s smarter communication built for modern
          customer expectations.
        </p>

        <div className="flex flex-col md:flex-row gap-[25px] p-4">
          <div className="flex-1 bg-[#f0fff0] p-6 rounded-xl">
            <h3 className="text-[20px] font-semibold text-[#0C4D45] mb-3">
              Our Vision
            </h3>
            <p>
              To become a trusted global platform that transforms WhatsApp into
              the most effective channel for business communication, customer
              engagement, and long-term growth.
            </p>
          </div>

          <div className="flex-1 bg-[#f0fff0] p-6 rounded-xl">
            <h3 className="text-[20px] font-semibold text-[#0C4D45] mb-3">
              Our Mission
            </h3>
            <p>
              Our mission is to empower businesses of all sizes with simple,
              secure, and scalable WhatsApp automation solutions. We aim to help
              brands connect with customers more efficiently, engage them
              meaningfully, and convert conversations into lasting relationships
              through faster, smarter, and more human communication.
            </p>
          </div>
        </div>
      </div>

      {/* Third Section */}
      <div className="max-w-[1200px] mx-auto px-5 py-16">
        <h2 className="text-[32px] font-bold text-[#0C4D45] text-center mb-4">
          What Anlook Does
        </h2>

        <div className="bg-[#0C4D45] p-10 rounded-xl max-w-[900px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/2 space-y-6 text-white ">
              <h3 className="font-bold">WhatsApp Campaign Management</h3>
              <p className="font-light">
                Launch bulk messaging campaigns, promotional broadcasts, and
                announcement messages with high delivery rates and measurable
                engagement. Anlook helps you reach customers at scale without
                sacrificing reliability.
              </p>

              <h3 className="font-bold">Personalized Customer Messaging</h3>
              <p classname="font-light">
                Send relevant, personalized messages using customer data and
                behavior insights. Deliver conversations that feel one-to-one,
                build trust, and drive higher response and conversion rates
              </p>
            </div>

            <div className="lg:w-1/2 space-y-6 text-white">
              <h3 className="font-bold">
                Automated Replies & Smart Chat Flows
              </h3>
              <p className="font-light">
                Automate common customer interactions with intelligent replies
                and guided chat journeys. Stay available 24/7, reduce response
                time, and handle customer queries efficiently without manual
                effort.
              </p>

              <h3 className="font-bold">Analytics & Performance Insights</h3>
              <p className="font-light">
                Monitor message delivery, customer engagement, and campaign
                performance in real time. Use actionable insights to optimize
                your WhatsApp strategy and improve results continuously.
              </p>
            </div>
          </div>
        </div>
      </div>
      <FaqSection />
      <CtaSection />
      <Footer />
    </>
  );
};

export default AboutUs;
